import { BaseSdk } from '../../base.sdk';
import { CreateTargetSearchDto, TargetSearchDto } from '@zaplify/prospects';

export class TargetSearchesSdk extends BaseSdk {
    async createTargetSearch(targetSearch: CreateTargetSearchDto) {
        return await this.post<TargetSearchDto>({ path: this.targetSearchesPath, payload: targetSearch });
    }
}
